import { useGetClaimsForCurrentUser } from '../api/user/user';

/**
 * Extracts the system year from a system version string
 * @param systemVersion - Version string in format "YYYY.X.X" (e.g., "2025.1.0")
 * @returns The year as a number, or null if the version is invalid
 */
const getSystemYear = (systemVersion: string | null | undefined): number | null => {
    if (!systemVersion) {
        return null;
    }
    return parseInt(systemVersion.split('.')[0]);
};

/**
 * Hook to get the current system year from user claims
 * @returns The system year as a number, or null if unavailable
 */
export const useSystemYear = (): number | null => {
    const { data: claims } = useGetClaimsForCurrentUser();
    return getSystemYear(claims?.systemVersion);
};
